const state = {
    timesheet: {},
    showEditModal: false
}

const mutations = {
    openEditModal(state,payload){
        state.showEditModal = payload.showEditModal
        if(payload.timesheet){
            state.timesheet = payload.timesheet
        }else{
            state.timesheet = {}
        }
    }
}

const actions = {
    openEditModal({commit}, payload){
        commit('openEditModal',payload)
    }
}

export default {
    namespaced: true,
    state, mutations, actions
}